import { FC } from 'react'
import {
  Badge,
  Box,
  Card,
  Flex,
  // Radio,
  Text,
  useRadio,
} from '@chakra-ui/react'
import { CheckCircle, CheckCircleNotChecked } from 'components/icons'

type Props = any & {
  isClassificationSelected: boolean
  badgeText: string
  label: string
  description: string
  color: string
  withoutDescription?: boolean
}

const ClassificationCard: FC<Props> = ({
  isClassificationSelected,
  badgeText,
  color,
  description,
  label,
  withoutDescription,
  ...radioProps
}) => {
  const { getInputProps, getRadioProps } = useRadio(radioProps)

  return (
    <Box as="label" cursor="pointer">
      <input {...getInputProps({})} hidden />
      <Card
        {...getRadioProps()}
        className="accessible"
        key={badgeText}
        bg={isClassificationSelected ? 'lightPrimary' : 'light'}
        borderWidth="2px"
        borderColor={isClassificationSelected ? 'primary' : 'trasparent'}
        filter={isClassificationSelected ? 'grayscale(0)' : 'grayscale(1)'}
        _hover={!isClassificationSelected ? { bg: 'lightPrimary' } : {}}
      >
        <Flex align="center" gap={2}>
          {isClassificationSelected ? <CheckCircle boxSize={6} /> : <CheckCircleNotChecked boxSize={6} />}
          {/* <Radio isChecked={isClassificationSelected ? true : false} size="lg" /> */}
          <Flex direction="column" gap={1}>
            <Flex align="center" gap={2}>
              <Badge variant="solid" colorScheme={color}>
                {label}
              </Badge>
              {/* <Text fontSize="md">{label}</Text> */}
            </Flex>
            {!withoutDescription && <Text>{description}</Text>}
          </Flex>
        </Flex>
      </Card>
    </Box>
  )
}

export default ClassificationCard
